export default __webpack_public_path__ + "static/media/indicator-pallette-mobile.01e0afd3.svg";